module.exports = __webpack_public_path__ + "img/car-running.9153ef93.svg";